import { useDispatch, useSelector } from 'react-redux'
import { updateUserFormObject, initFormObjects } from '@store/slice/usersSlice'
import { updateNotification } from '@store/slice/mainSlice'
import { post, get } from '@util/xhrAPI'
import { useTranslation } from 'react-i18next'
import { useNavigate, useLocation } from 'react-router-dom'
import { ROLE_SUPER_ADMIN, ROLE_USER } from '@router/Routes'
import Div from '@ui/layout/Div'
import Buttons from '@ui/elements/Buttons'
import { userInfosFormFields, userSaveUrl } from '@form/userInfosFormFields'
import useToggle from '@hook/useToggle'
import useStoreUpdate from '@hook/useStoreUpdate'
import useFormData from '@hook/useFormData'
import useDynamicForm from '@hook/useDynamicForm'
import useMainData from '@hook/useMainData'
import useRestrictRoute from '@hook/useRestrictRoute'
import { useEffect } from 'react'

const Profile = () => {
  const { userFormObject, errors } = useSelector(state => state.users)
  const { data, logguedUser } = useSelector(state => state.main)
  const dispatch = useDispatch()
  const loadData = useMainData()
  const [t] = useTranslation('user')
  const renderFormData = useFormData()
  const [isLoading, toggleLoading] = useToggle(false)
  const toggleDynamicForm = useDynamicForm()
  const [updateFormObject, updateFormObjectProp] = useStoreUpdate(dispatch, updateUserFormObject, userFormObject)
  const isUserAuthorized = useRestrictRoute()
  const navigate = useNavigate()
  const location = useLocation()

  const saveForm = () => {
    post(userSaveUrl, renderFormData(userFormObject), response => {
      toggleLoading()
      const { code, errors } = response
      if (code === 200 && !errors.length) {
        window.scroll({ top: 0 })
        if (logguedUser.id !== userFormObject.id) {
          dispatch(initFormObjects())
        }

        dispatch(updateNotification({ type: 'is-success', message: t('alerts.user_saved') }))
      }
      toggleLoading()
    })
  }

  const fetchInitialData = () => {
    const dataObject = {
      cities: 'cities'
    }
    loadData(dataObject)
  }

  useEffect(() => {
    if (ROLE_USER['profile'] === location.pathname && logguedUser.id !== userFormObject.id) {
      get(`${import.meta.env.VITE_API_URL}/api/users/${logguedUser.id}`, response => {
        const { user } = response
        dispatch(updateUserFormObject(user))
        fetchInitialData()
      })
    }
  }, [])

  return (
    <Div cssClass='create-user'>
      <Div cssClass='form-header'>
        {
          'undefined' !== typeof userFormObject.id && logguedUser.id !== userFormObject.id && isUserAuthorized('users', logguedUser.roles)
            ? <Buttons buttons={
              {
                cssClass: 'back-to-list is-info',
                callback: () => navigate(ROLE_SUPER_ADMIN['users']),
                text: t('actions.back_to_users_list'),
                icon: 'icon-keyboard_arrow_left'
              }
            } />
            : <></>
        }

        <h2 className='scene-title'>{t('titles.my_infos')}</h2>
      </Div>
      <Div cssClass='form columns is-multiline'>
        {userFormObject.id
          ? userInfosFormFields(userFormObject, updateFormObject, updateFormObjectProp, saveForm, errors, isLoading, t, data, toggleDynamicForm)
          : <></>
        }
      </Div>
    </Div>
  )
}

export default Profile